import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material"
import { Link } from "react-router-dom"
import PqrCard from "../../components/pqrCard"
import useStyles from "./style"
import { icons } from "../../utils"

const PqrsfList = () => {
  const classes = useStyles()

  return (
    <Box className={classes.body}>
      <Box className={classes.listContainer}>
        <Box className={classes.listBody}>
          <Box className={classes.listHeader}>
            <Box className={classes.titleContainer}>
              <Typography variant="h1" className={classes.title}>
                BANDEJA DE PQRSF
              </Typography>
            </Box>
            <Box className={classes.subTitle}>
              <Typography>
                Listado de PQRSF que has gestionado hasta el momento.
                <br /> Ingresa número de radicado para visualizar el estado de
                tu PQRSF.
              </Typography>
            </Box>
          </Box>
          <Box className={classes.searchBar}>
            <TextField
              label="Buscar"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {icons("search")}
                  </InputAdornment>
                ),
              }}
              sx={{ width: 360 }}
              variant="outlined"
              className={classes.search}
            />
          </Box>
          <Box className={classes.list}>
            <PqrCard />
          </Box>
          <Box className={classes.buttonContainer}>
            <Button
              variant="contained"
              className={classes.inputButton}
              component={Link}
              to="/form"
            >
              Nueva PQRSF
            </Button>
          </Box>
        </Box>
      </Box>
      <Box className={classes.imgContainer}>imagen</Box>
    </Box>
  )
}

export default PqrsfList
